/* Recenzii (Enormapps) pe mobil: slider cu swipe, sageti si indicator de pozitie.
   Widget-ul isi randeaza DOM-ul tarziu, asa ca asteptam aparitia lui. */
(function () {
  'use strict';
  function enhance(list) {
    if (list.__slider || window.innerWidth > 767) { return; }
    var items = list.querySelectorAll('.enorm-item-list');
    if (items.length < 2) { return; }
    list.__slider = true;
    var wrap = document.createElement('div'); wrap.className = 'reviews-slider';
    list.parentNode.insertBefore(wrap, list); wrap.appendChild(list);
    var nav = document.createElement('div'); nav.className = 'reviews-slider__nav';
    nav.innerHTML = '<button type="button" class="reviews-slider__btn reviews-slider__btn--prev" aria-label="Recenzia anterioară">←</button>' +
                    '<span class="reviews-slider__dots" aria-hidden="true"></span>' +
                    '<button type="button" class="reviews-slider__btn reviews-slider__btn--next" aria-label="Recenzia următoare">→</button>';
    wrap.appendChild(nav);
    var dots = nav.querySelector('.reviews-slider__dots');
    for (var i = 0; i < items.length; i++) { var d = document.createElement('i'); dots.appendChild(d); }
    function step() { return items[0].getBoundingClientRect().width + 12; }
    function index() { return Math.round(list.scrollLeft / step()); }
    function update() {
      var cur = index();
      dots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
      nav.querySelector('.reviews-slider__btn--prev').disabled = cur <= 0;
      nav.querySelector('.reviews-slider__btn--next').disabled = cur >= items.length - 1;
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.reviews-slider__btn'); if (!b) { return; }
      var dir = b.classList.contains('reviews-slider__btn--next') ? 1 : -1;
      list.scrollTo({ left: (index() + dir) * step(), behavior: 'smooth' });
    });
    var t; list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 80); }, { passive: true });
    update();
  }
  function scan() { document.querySelectorAll('#enormReviews .enormReivewsView').forEach(enhance); }
  var root = document.getElementById('enormReviews');
  if (!root) { return; }
  scan();
  var mo = new MutationObserver(function () { scan(); });
  mo.observe(root, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 30000);
})();

/* Benzi derulabile (miniaturi, recenzii): drag cu mouse-ul pe ecranele tactile cu mouse / desktop ingust */
(function () {
  'use strict';
  function dragScroll(el) {
    if (el.__drag) { return; } el.__drag = true;
    var down = false, startX = 0, startLeft = 0, moved = false;
    el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { return; } down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft; });
    el.addEventListener('pointermove', function (e) { if (!down) { return; } var dx = e.clientX - startX; if (Math.abs(dx) > 4) { moved = true; } el.scrollLeft = startLeft - dx; });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { el.addEventListener(ev, function () { down = false; }); });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  function boot() { document.querySelectorAll('.product-images .gallery, #enormReviews .enormReivewsView').forEach(dragScroll); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  setTimeout(boot, 4000);
})();

/* Miniaturi produs: sageti stanga/dreapta peste banda, doar cand nu incap toate */
(function () {
  'use strict';
  function arrows(list) {
    if (list.__arrows) { return; } list.__arrows = true;
    var wrap = document.createElement('div'); wrap.className = 'gallery-strip';
    list.parentNode.insertBefore(wrap, list); wrap.appendChild(list);
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'gallery-strip__btn gallery-strip__btn--prev'; next.className = 'gallery-strip__btn gallery-strip__btn--next';
    prev.setAttribute('aria-label', 'Imaginile anterioare'); next.setAttribute('aria-label', 'Imaginile următoare');
    prev.innerHTML = '&larr;'; next.innerHTML = '&rarr;';
    wrap.appendChild(prev); wrap.appendChild(next);
    function update() {
      var overflow = list.scrollWidth > list.clientWidth + 2;
      wrap.classList.toggle('has-overflow', overflow);
      prev.hidden = !overflow || list.scrollLeft <= 2;
      next.hidden = !overflow || list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    function go(dir) { list.scrollBy({ left: dir * Math.max(list.clientWidth * 0.7, 120), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    var t; list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(update); }
    update(); setTimeout(update, 600);
  }
  function boot() { document.querySelectorAll('.product-images .gallery').forEach(arrows); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
